import {useLocale} from '@/providers/locale'
import {getCurrencyForLocale, currencySymbolMap} from '@/utils/currency-formatter'

const useCurrency = () => {
    const currentLocale = useLocale()
    const code = getCurrencyForLocale(currentLocale.code)
    const symbol = currencySymbolMap[code]

    const formatter = new Intl.NumberFormat(currentLocale.code, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'symbol',
    })

    const getFormattedCurrency = (value: number) => {
        const formattedValue = formatter.format(value)

        // Remove decimal values if they are 0
        return formattedValue.replace(/([.,]00)(\s?[\u00A0]?[^\d]*)$/, '$2')
    }

    return {
        code,
        symbol,
        getFormattedCurrency,
    }
}

export default useCurrency
